import { Suspense, lazy } from "react";
import "./App.css";
import "./redesign.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";

import NavBar from "./NavBar";
import { AuthProvider } from "./AuthContext";
import Footer from "./Footer";
import PublicNav from "./PublicNav";
import { ThemeProvider } from '@mui/material/styles';
import managementTheme from './managementTheme';

const EventForm = lazy(() => import("./EventForm"));
const Events = lazy(() => import("./Events"));
const EditEventForm = lazy(() => import("./EditEventForm"));
const Analysis = lazy(() => import("./Analysis"));
const HomePage = lazy(() => import("./HomePage"));
const LoginPage = lazy(() => import("./LoginPage"));
const SignUp = lazy(() => import("./SignUp"));
const TermsOfUse = lazy(() => import("./TermsOfUse"));
const PrivacyPolicies = lazy(() => import("./PrivacyPolicies"));
const EventRedirect = lazy(() => import("./EventRedirect"));
const ArtistProfiles = lazy(() => import("./ArtistProfiles"));
const ArtistProfileDetail = lazy(() => import("./ArtistProfileDetail"));
const GoogleMapsRoute = lazy(() => import("./GoogleMapsRoute"));
const BrowseEvents = lazy(() => import("./BrowseEvents"));

function RouteLoading() {
  return (
    <main
      aria-live="polite"
      style={{ minHeight: "70vh", paddingTop: "120px", textAlign: "center" }}
    >
      Loading…
    </main>
  );
}

function SiteRoutes() {
  const location = useLocation();
  const background = location.state?.backgroundLocation;
  const publicPage =
    location.pathname === "/" ||
    location.pathname === "/browse-events" ||
    ["/login", "/signup", "/terms-of-use", "/privacy-policy", "/about", "/artists", "/organizer", "/venue"].includes(location.pathname) ||
    /^\/event\//.test(location.pathname);
  return (
    <ThemeProvider theme={managementTheme}><div className={publicPage ? 'nuun-site-shell' : 'nuun-management-shell'}>
      {publicPage ? <PublicNav /> : <NavBar />}
      <Suspense fallback={<RouteLoading />}>
        <Routes location={background || location}>
          <Route path="/" element={<HomePage />} />
          <Route path="/browse-events" element={<BrowseEvents />} />
          <Route path="/event/:id" element={<EventRedirect />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/privacy-policy" element={<PrivacyPolicies />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/events" element={<Events />} />
          <Route path="/analysis" element={<Analysis />} />
          <Route path="/signup" element={<SignUp />} />
          <Route element={<GoogleMapsRoute />}>
            <Route path="/event-form" element={<EventForm />} />
            <Route path="/events/edit-event/:id" element={<EditEventForm />} />
          </Route>
          <Route path="/about" element={<Navigate to="/#why-nuun" replace />} />
          <Route path="/artists" element={<Navigate to="/#contact" replace />} />
          <Route path="/organizer" element={<Navigate to="/#contact" replace />} />
          <Route path="/venue" element={<Navigate to="/#contact" replace />} />
          <Route path="/artist-profiles" element={<ArtistProfiles />} />
          <Route
            path="/artist-profile/:artistId"
            element={<ArtistProfileDetail />}
          />
        </Routes>
        {background && (
          <Routes>
            <Route path="/event/:id" element={<EventRedirect overlay />} />
          </Routes>
        )}
      </Suspense>
      <Footer />
    </div></ThemeProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="app">
        <Router>
          <SiteRoutes />
        </Router>
      </div>
    </AuthProvider>
  );
}

export default App;
